const sitekey = "6Ld7Tm0UAAAAAOgZ2yIwrQVIXXiz-uvDcea-V07O";

module.exports = {
  sitekey
};
